import React from 'react'
import { connect } from 'react-redux'
import { Grid, Table } from 'semantic-ui-react'
import { Button, Form, Input, Label, Header, Segment, Image , Radio, Modal, Icon, Popup} from 'semantic-ui-react'
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import {expanseUser, updateOwnAvatar} from '../reducers/user/actions'
import StatisticUser from './StatisticUser';
import AvatarEditor from './AvatarEditor'
//const  MobileDetect = require('mobile-detect');
//const md = new MobileDetect(req.headers['user-agent']);
import {md} from '../reducers/user/actions'

export const inlineStyle = {
    modal : {
      marginTop: '0px !important',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    modalAvatar : {
        marginTop: '0px !important',
        marginLeft: 'auto',
        marginRight: 'auto',
        width:'400px',
      }
  };

class ExpanseUser extends React.Component {
    constructor (props) {
        super(props);
        this.state = { country: 'Italia', 
                       region: '' , 
                       open:false,
                       claim: '', 
                       real_name:'', 
                       paypal_account:'',
                       has_webcam:0,
                       username:'',
                       email:'',
                       avatar: ''
                    };
      }

    componentDidMount() {
        if (this.props.onMount)
            this.props.onMount()
        if (this.props.user.exp_user){
            this.setState(this.props.user.exp_user);
            this.setState(this.props.user)
        }
        this.setState({open:true})
        if (this.props.user.exp_user.from){
            if (!(this.props.user.exp_user.from.split("/")[0] === 'Italia'))
                this.selectCountry('Estero');
            this.selectRegion(this.props.user.exp_user.from.split("/")[1])
        }
    }

    selectCountry = (val) => this.setState({ country: val });
     
    selectRegion = (val) => this.setState({ region: val });


    mainClose = () => {
        this.setState({open:false}); 
        this.props.onClose()
    }
    handleRealName = (event) => this.setState({real_name: event.target.value});
    handleUserName = (event) => this.setState({username: event.target.value});
    handlePaypal = (event) => this.setState({paypal_account: event.target.value});
    handleClaim = (event)  => this.setState({claim: event.target.value});
    handleWebcam = (event) => {
            this.setState({has_webcam: 1-this.state.has_webcam});
    }

    handleAvatar = (avatar) =>{
        this.setState({avatar: avatar});
        this.props.onAvatarUploaded(avatar)
    }

    handleSubmit = (event) => {
        event.preventDefault();
        this.props.onSubmit(this.props.socket,this.props.user,this.state);
        this.mainClose();
    }

    
    
    render() {
        if (!this.state.open) return null;
        const { user, token } = this.props
        const exp_user = user.exp_user;
        const { country, region } = this.state;
        return (
            <Grid columns={1}>
                <Grid.Column>
                 <Form  style={{ textAlign: 'left'}}>
                <Segment style={{ maxWidth: '800px', margin: 'auto' }}>
                    <Label color='purple' ribbon>PROFILO UTENTE</Label>
                    <div style={{ textAlign: 'center' }}>
                        <Header as='h1' style={{ fontWeight: 'normal' }}>
                            <Image src={exp_user.avatar} size='large' circular />
                                Ciao {user.username} 
                        </Header>
                        <Header as='h3' style={{ fontWeight: 'normal' }}>Qui puoi personalizzare il tuo profilo utente</Header>
                        <Form.Group widths='equal' style={{ textAlign: 'center'}}>
                        <Form.Field control={Input} label='Nome Utente' onChange= {this.handleUserName} placeholder= {this.state.username} readOnly = {this.props.gameIsOn}/>
                        <Form.Field control={Input} label='E-mail' placeholder={this.state.email}  readOnly/>
                        </Form.Group>
                        <Form.Group widths='equal'>
                        <Form.Field control={Input} onChange= {this.handleRealName} label='Il mio nome vero' placeholder= {this.state.real_name?this.state.real_name:'Il mio nome vero'}/>
                        <Form.Field control={Input} onChange= {this.handlePaypal} label='Paypal Account' placeholder= {this.state.paypal_account?this.state.paypal_account:'paypal'}/>
                        </Form.Group>
                        <Table>
                        <Table.Body>
                        <Table.Row>  
                        <Table.Cell width={3} textAlign='center'>
                         Da dove giochi?
                        </Table.Cell>
                        <Table.Cell width={7}>
                        <CountryDropdown 
                            value={country}    
                            showDefaultOption={false} 
                            onChange={(val) => this.selectCountry(val)} 
                                style={{
                                    backgroundColor: '#da00f9',
                                    color: '#ffe445',
                                }}
                        />
                        </Table.Cell>
                        <Table.Cell width={7}>
                        <RegionDropdown 
                            country={country} 
                            value={region} 
                            defaultOptionLabel="Puoi essere più specifico?"
                            onChange={(val) => this.selectRegion(val)}
                            style={{
                                backgroundColor: '#da00f9',
                                color: '#ffe445',
                            }}
                        />
                        </Table.Cell>
                        </Table.Row>
                        </Table.Body>
                        </Table>
                        
                        <Form.Field control={Input} label='Claim' onChange= {this.handleClaim} placeholder= {this.state.claim?this.state.claim:'Inserisci qui una frase che farà di te un figo'}/>
                        <Grid columns = {2}>
                        <Grid.Column>
                        <Icon  name='video camera' size = 'large'/> <Radio toggle onChange= {this.handleWebcam} readOnly={false} checked={this.state.has_webcam===1}  label='Ho una webcam'/>  
                        </Grid.Column>
                        <Grid.Column>
                        Sei connesso da {
                            md.mobile()? 
                            <Label><Icon  name='mobile' size = 'large'/>Mobile </Label>
                            :
                            <Label><Icon  name='laptop' size = 'large'/>Laptop </Label>
                        }
                        </Grid.Column>
                        </Grid>
                        <Grid >
                        <Grid.Column mobile={16} tablet={8} computer={5}>
                        <Popup trigger={
                            <Label>
                         <Modal trigger={ 
                        <Button content='Statistiche' fluid positive/>
                        }  style={inlineStyle.modal}>
                        <StatisticUser exp_user={exp_user}/>    
                        </Modal>
                        </Label>} content='Visualizza statistiche'  position='bottom center' />
                        </Grid.Column>                    
                        <Grid.Column mobile={16} tablet={8} computer={6}>
                        <Popup trigger={
                            <Label>
                         <Button content = 'Elimina Utente' negative fluid/>  
                         </Label> 
                            } content={<Button color='red' content='Questa azione non è reversibile. Clicca qui se vuoi proseguire?' user= {user} onClick = {this.props.deleteUser}  />}
                            on='click'
                            position='top center'
                        />                       </Grid.Column>
                        <Grid.Column mobile={16} tablet={8} computer={5}>
                        <Popup trigger={
                            <Label>
                            <Modal trigger={<Button positive fluid>Aggiorna Avatar</Button>} style={inlineStyle.modalAvatar}>
                            <Modal.Content>
                                <AvatarEditor userToken={token} src={exp_user.avatar} 
                                              onAvatarUploaded={this.handleAvatar} />
                            </Modal.Content>
                            </Modal>
                            </Label>} content='Cambia il tuo avatar'  position='bottom center' />
                            </Grid.Column>                            
                        <Grid.Column mobile={16} tablet={16} computer={16}>
                        <Button type="submit" primary fluid onClick={this.handleSubmit}>Salva</Button>
                        </Grid.Column >
                        <Grid.Column mobile={16} tablet={16} computer={16}>
                        <Button type="button" primary inverted fluid onClick={this.mainClose}> Chiudi</Button>
                        </Grid.Column>                     
                        </Grid>
                    </div>
                </Segment>
            </Form>
                </Grid.Column>
            </Grid>
        )
    }
}

const mapStateToProps = (state) => ({
    user: state.user,
    socket: state.socket,
    token: state.currentToken
})

const mapDispatchToProps = (dispatch) => ({
    onSubmit: (socket, user , {username, country,region,claim,real_name,paypal_account,has_webcam, avatar}) => dispatch(expanseUser(socket, user.id, country+"/"+region,claim,real_name,paypal_account,has_webcam, avatar, username)),
    onAvatarUploaded: (avatar) => dispatch(updateOwnAvatar(avatar))
})


export default connect(
    mapStateToProps, 
    mapDispatchToProps
)(ExpanseUser)



// WEBPACK FOOTER //
// ./src/components/ExpanseUser.js